import { refreshOnce } from '../auth.js';

const BASE = process.env.REACT_APP_NOTIFICATIONS_API_URL;

export function isExpired(token, skew = 60) {
  try {
    const p = JSON.parse(
      atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    return !p.exp || Date.now() / 1000 >= p.exp - skew;
  } catch {
    return true;
  }
}

async function authedFetch(url, options = {}, { retried = false } = {}) {
  let idToken = localStorage.getItem('id_token');
  if (idToken && isExpired(idToken)) {
    await refreshOnce();
    idToken = localStorage.getItem('id_token');
  }

  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (res.status === 401 && !retried) {
    await refreshOnce();
    return authedFetch(url, options, { retried: true });
  }
  return res;
}

export async function fetchPendingReconcile(projectId) {
  const res = await authedFetch(`${BASE}/reconcile?projectId=${projectId}`);
  if (!res.ok) throw new Error('Failed to load pending deliverables');
  const data = await res.json();
  return data.pending || [];
}

export async function linkDeliverable(projectId, linkId, targetLinkId) {
  const res = await authedFetch(`${BASE}/reconcile/${linkId}/link`, {
    method: 'POST',
    body: JSON.stringify({ projectId, targetLinkId }),
  });
  if (res.status === 409) {
    const err = new Error('This document was changed by someone else. Refresh and try again.');
    err.code = 'CONFLICT';
    throw err;
  }
  if (!res.ok) throw new Error('Failed to link deliverable');
  return res.json();
}

export async function dismissDeliverable(projectId, linkId) {
  const res = await authedFetch(`${BASE}/reconcile/${linkId}/dismiss`, {
    method: 'POST',
    body: JSON.stringify({ projectId }),
  });
  if (!res.ok) throw new Error('Failed to dismiss');
  return res.json();
}